/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

.snackbar-alert {
  box-shadow:
    0 3px 5px -1px #0003,
    0 6px 10px #00000024,
    0 1px 18px #0000001f;
  border-radius: 4px;
  position: absolute !important;
}
